import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import IconButton from '@material-ui/core/IconButton';



const useStyles = makeStyles((theme) => ({
    toTop: {
        animation: 'slideAnimation 1s ease forwards',
        zIndex: 2,
        position: 'fixed',
        bottom: '6vh',
        backgroundColor: '#FAFAFA',
        color: '#FAFAFA',
        "&:hover, &.Mui-focusVisible": {
            transition: '1s',
            color: '#202020',
            backgroundColor: '#FAFAFA',
            
            border: '1px solid #ccc'
        },
        [theme.breakpoints.up('xs')]: {
            right: '2%',
            backgroundColor: '#202020',
            transition: '1s',
        },
        [theme.breakpoints.up('lg')]: {
            right: '2.3%',
        },
    }
})
)

const ScrollToTop = ({
    showBelow,
    currentProject,
    darkMode
}) => {

    const classes = useStyles();
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [show, setShow] = useState(showBelow ? false : true)

    const handleScroll = () => {
        if (window.pageYOffset > showBelow) {
            if (!show) setShow(true)
        } else {
            if (show) setShow(false)
        }
    }

    const handleClick = () => {
        window[`scrollTo`]({ top: 0, behavior: `smooth`})
    }
    

    
    useEffect(() => {
        if (showBelow) {
            window.addEventListener(`scroll`, handleScroll)
            return () => window.removeEventListener(`scroll`, handleScroll)
        }
    })

    useEffect(() => {
        const handleResize = () => {
        setWindowWidth(window.innerWidth);
        };
    
        window.addEventListener('resize', handleResize);
    
        return () => {
        window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div>
            {show && !currentProject && !darkMode &&
                <IconButton onClick={handleClick} className={classes.toTop } 
                style={{
                ...(windowWidth <= 1024 && {
                    bottom: '10vh',
                }),
                ...(windowWidth <= 730 && {
                    width: '40px',
                    height: '40px',
                    bottom: '20vh',
                }),
                ...(windowWidth <= 480 && {
                    width: '40px',
                    height: '40px',
                    bottom: '21vh',
                    right: '4.5%',
                }),
                ...(windowWidth <= 320 && {
                    width: '35px',
                    height: '35px',
                    bottom: '27vh',
                    right: '7%',
                }),
                }} 
                aria-label="to top" 
                component="span">
                    <ExpandLessIcon />
                </IconButton>
            }
        </div>
    )
}
export default ScrollToTop